<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isGreyManager()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>User Types</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<!-- main row for all icons  -->
<div class="col-md-12">
	<div class="card card-primary card-outline">
		<div class="card-body overflow-auto">
      <img v-if="users==''" src="../images/nodata.svg">	
			<datatable style="margin-top:1%;" :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy" v-else>
      	<tbody>
        	<tr v-if="users!=''" v-for="(user, index) in users" :key="user.id">
          	<td>{{user.name}}</td>
          	<td>{{user.email}}</td>
          	<td>{{user.mobile}}</td>
            <td v-if="user.isAdmin==1" class="badge-success">
          		<div class="custom-control custom-switch">
              	<input type="checkbox" class="custom-control-input" :id="'adminactive'+index" checked @input="change('admin', 0, user.id)">
              	<label class="custom-control-label" :for="'adminactive'+index">Active</label>
              </div>
          	</td>
          	<td v-else class="badge-danger">
          		<div class="custom-control custom-switch">
              	<input type="checkbox" class="custom-control-input" :id="'admini'+index" @input="change('admin', 1, user.id)">
              	<label class="custom-control-label" :for="'admini'+index">Inactive</label>
              </div>
          	</td>
          	<td v-if="user.isAuctionManager==1" class="badge-success">
          		<div class="custom-control custom-switch">
              	<input type="checkbox" class="custom-control-input" :id="'auctioneeractive'+index" checked @input="change('auctioneer', 0, user.id)">
              	<label class="custom-control-label" :for="'auctioneeractive'+index">Active</label>
              </div>
          	</td>
          	<td v-else class="badge-danger">
          		<div class="custom-control custom-switch">
              	<input type="checkbox" class="custom-control-input" :id="'auctioneeri'+index" @input="change('auctioneer', 1, user.id)">
              	<label class="custom-control-label" :for="'auctioneeri'+index">Inactive</label>
              </div>
          	</td>
          	<td v-if="user.isSeller==1" class="badge-success">
          		<div class="custom-control custom-switch">
              	<input type="checkbox" class="custom-control-input" :id="'sellera'+index" checked @input="change('seller', 0, user.id)">
              	<label class="custom-control-label" :for="'sellera'+index">Active</label>
              </div>
          	</td>
          	<td v-else class="badge-danger">
          		<div class="custom-control custom-switch">
              	<input type="checkbox" class="custom-control-input" :id="'selleri'+index" @input="change('seller', 1, user.id)">
              	<label class="custom-control-label" :for="'selleri'+index">Inactive</label>
              </div>
          	</td>
          	<td v-if="user.isBuyer==1" class="badge-success">
          		<div class="custom-control custom-switch">
              	<input type="checkbox" class="custom-control-input" :id="'buyera'+index" checked @input="change('buyer', 0, user.id)">
              	<label class="custom-control-label" :for="'buyera'+index">Active</label>
              </div>
          	</td>
          	<td v-else class="badge-danger">
          		<div class="custom-control custom-switch">
              	<input type="checkbox" class="custom-control-input" :id="'buyeri'+index" @input="change('buyer', 1, user.id)">
              	<label class="custom-control-label" :for="'buyeri'+index">Inactive</label>
              </div>
          	</td>
          </tr>				
        </tbody>
      </datatable>
    </div>
    <div class="card-footer">
    	<pagination :pagination="pagination"
       	@prev="getUsers(pagination.prevPageUrl)"
        @next="getUsers(pagination.nextPageUrl)"
      ></pagination>
		</div>
	</div>
</div>
</section>
    <br>
      <br>
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isGreyManager()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		import Datatable from '../datatable.vue';
    import Pagination from '../pagination.vue';
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        components: {datatable:Datatable, pagination:Pagination},
        
        
        created(){
        	this.getUsers();
        },
        
    		data(){
        	let sortOrders = {};
      		let columns = [
      			{width:'20%', label:'Name', name:'name'},
      			{width:'20%', label:'E-Mail', name:'email'},
      			{width:'20%', label:'Mobile', name:'mobile'},
      			{width:'10%', label: 'Admin Status', name:'isAdmin'},
      			{width:'10%', label: 'Auctioneer Status', name:'isAuctionManager'},
      			{width:'10%', label:'Seller Status', name:'isSeller'},
      			{width:'10%', label:'Buyer Status', name:'isBuyer'}
      		];
      		columns.forEach((column) => {
          	sortOrders[column.name]=-1;
        	});
        	return{
        		columns: columns,
        		sortKey: 'id',
        		sortOrders: sortOrders,
        		tableData: {
        			draw: 0,
        			length: 10,
        			column: 0,
        			dir: 'desc'
        		},
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
            	path: ''
         		},
         		users: [],
         		errors: []
         }
       },
       
       methods: {
       	configPagination(data){
      		this.pagination.lastPage=data.lastPage;
         	this.pagination.currentPage=data.current_page;
    	  	this.pagination.total=data.total;
        	this.pagination.lastPageUrl=data.last_page_url;
       		this.pagination.nextPageUrl=data.next_page_url;
       		this.pagination.prevPageUrl=data.prev_page_url;
     		 	this.pagination.from=data.from;
        	this.pagination.to=data.to;
        	this.pagination.path=data.path;
    		},
  
      	sortBy(key){
     			this.sortKey=key;
      		this.sortOrders[key] = this.sortOrders[key]*-1;
       	  this.tableData.column = this.getIndex(this.columns, 'name', key);
 	     	  this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
    		},
     		
     		getIndex(array, key, value){
       		return array.findIndex(i => i[key] == value)
       	},
       	
       	getUsers(url="/api/getUsers"){
       		axios.post(url, {params: this.tableData})
       		.then(response => {
       			this.users = response.data.data.data;
       			this.configPagination(response.data.data);
       		})
       	},
        
        change(role, code, id){
        	switch(role){
        		case 'admin':
        			axios.post('/api/changeAdminStatus', {id: id, code:code})
        			.then(() => {
        				this.getUsers(this.pagination.path+'?page='+this.pagination.currentPage);
        			});
        			break;
        		case 'auctioneer':
        			axios.post('/api/changeAuctioneerStatus', {id: id, code:code})
        			.then(() => {
        				this.getUsers(this.pagination.path+'?page='+this.pagination.currentPage);
        			});
        			break;
        		case 'seller':
        			axios.post('/api/changeSellerStatus', {id: id, code:code})
        			.then(() => {
        				this.getUsers(this.pagination.path+'?page='+this.pagination.currentPage);
        			});
        			break;
        		case 'buyer':
        			axios.post('/api/changeBuyerStatus', {id: id, code:code})
        			.then(() => {
        				this.getUsers(this.pagination.path+'?page='+this.pagination.currentPage);
        			});
        			break;
        		default:
        			console.log("Null");
        	}
        }
      }
    }
</script>
